import React, { useState } from 'react';
import { Box, Popper } from '@mui/material';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { StatusButton, StatusButtonDashedLine } from '../styles';
import upArrowWhite from 'assets/images/upArrowWhite.svg';
import downArrowWhite from 'assets/images/downArrowWhite.svg';
import { ExcursionStatusAPI } from 'interfaces/IExcursion';
import { UserType } from 'interfaces/IUser';

interface ExcursionStatusDropdownProps {
  id: number;
  status: ExcursionStatusAPI;
  userType: UserType | null;
  onAction: (id: number, action: 'approve' | 'refuse' | 'send_bill', status: ExcursionStatusAPI) => void;
}

const ExcursionStatusDropdown: React.FC<ExcursionStatusDropdownProps> = ({ id, status, userType, onAction }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(isOpen ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Definir a classe CSS de cada status
  const statusClass =
    {
      [ExcursionStatusAPI.APPROVED]: 'approvedBadge',
      [ExcursionStatusAPI.REFUSED]: 'reprovedBadge',
      [ExcursionStatusAPI.PROCESSING]: 'processingBadge',
      [ExcursionStatusAPI.ANNALYSIS]: 'annaliseBadge',
      [ExcursionStatusAPI.PAYMENT_APPROVED]: 'approvedBadge',
      [ExcursionStatusAPI.PAYMENT_DENIED]: 'reprovedBadge',
      [ExcursionStatusAPI.CANCELED]: 'canceledBadge',
      [ExcursionStatusAPI.NOT_DEFINED]: 'canceledBadge',
      [ExcursionStatusAPI.BILL_SENT]: 'billSent',
    }[status] || 'defaultBadge';

  // Apenas exibe dropdown para perfis administrativos e se o status for "Em Processamento" ou "Isenção em Análise"
  const shouldShowDropdown =
    ['tour-admin', 'admin', 'setur-excursion', 'setur-dados'].includes(userType || '') &&
    (status === ExcursionStatusAPI.PROCESSING ||
      status === ExcursionStatusAPI.ANNALYSIS ||
      status === ExcursionStatusAPI.BILL_SENT);

  if (!shouldShowDropdown) {
    return <span className={statusClass}>{status}</span>;
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <StatusButton className={statusClass} onClick={handleClick}>
          {status}
          <span className="arrowIcon" style={{ marginLeft: '5px' }}>
            {isOpen ? <img src={upArrowWhite} alt="Fechar" /> : <img src={downArrowWhite} alt="Abrir" />}
          </span>
        </StatusButton>

        <Popper open={isOpen} anchorEl={anchorEl} placement="bottom-start">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              border: 1,
              p: 1,
              borderColor: '#ccc',
              borderRadius: 3,
              bgcolor: 'background.paper',
            }}>
            {status === ExcursionStatusAPI.PROCESSING && (
              <>
                <StatusButton
                  className="billSent"
                  onClick={() => {
                    onAction(id, 'send_bill', status);
                    handleClose();
                  }}>
                  Boleto Enviado
                </StatusButton>
                <StatusButtonDashedLine />
              </>
            )}

            <StatusButton
              className="approvedBadge"
              onClick={() => {
                onAction(id, 'approve', status);
                handleClose();
              }}>
              {status === ExcursionStatusAPI.PROCESSING || status === ExcursionStatusAPI.BILL_SENT
                ? 'Pagamento Aprovado'
                : 'Isenção Aprovada'}
            </StatusButton>
            <StatusButtonDashedLine />
            <StatusButton
              className="reprovedBadge"
              onClick={() => {
                onAction(id, 'refuse', status);
                handleClose();
              }}>
              {status === ExcursionStatusAPI.PROCESSING || status === ExcursionStatusAPI.BILL_SENT
                ? 'Pagamento Recusado'
                : 'Isenção Reprovada'}
            </StatusButton>
          </Box>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default ExcursionStatusDropdown;
